import request from '@/utils/httpRequest'

export function save(data) {
    return request({
        url: '/app/photo/save',
        method: 'post',
        data
    })
}

export function photoList(data) {
    return request({
        url: '/app/photo/list',
        method: 'get',
        params: data
    })
}

export function deletePhoto(pid) {
    return request({
        url: '/app/photo/delete/' + pid,
        method: 'post'
    })
}